export default __webpack_public_path__ + "static/media/404.0cef8f3d.png";